import { encrypt, decrypt } from '@services/encryptionService';

export const setLocalStorage = async <T>(key: string, value: T) => {
  const encrypted = await encrypt(JSON.stringify(value));
  localStorage.setItem(key, encrypted);
};

export const getLocalStorage = async <T>(key: string): Promise<T | null> => {
  const encrypted = localStorage.getItem(key);
  if (!encrypted) return null;

  try {
    const decrypted = await decrypt(encrypted);
    return JSON.parse(decrypted);
  } catch {
    return null;
  }
};

export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};
